import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { deleteCategoryData } from '../../../../actionCreators/category';
import './ContactLensCarousel.scss';

const ContactLensCarousel = props => {
  const { data, isMobile = false, history, categoryData, deleteCategoryData } = props;
  const [currentProduct, setCurrentProduct] = useState();

  const nextArrowRef = useRef();
  const prevArrowRef = useRef();
  const innerRef = useRef();
  const outerRef = useRef();

  const { optionsMapping, colorOptions, powerOptions, activeProductData } = useMemo(() => {
    let optionsMapping;
    let colorOptions;
    let powerOptions;
    let activeProductData;
    if (data?.additionalOptions) {
      const options = data.additionalOptions?.options;
      optionsMapping = data.additionalOptions?.optionsMapping;
      colorOptions = options.filter(i => i?.id === 'color')?.[0]?.optionList;
      powerOptions = options?.filter(i => i?.id === 'power')?.[0];
      optionsMapping
        ?.filter(op => op?.productId === data?.id)
        ?.forEach(item => {
          const currentColorProducts = colorOptions?.filter(c => c?.id === item?.color);
          const currentPower = powerOptions?.optionList?.filter(p => p?.id === item?.power)?.[0];
          activeProductData = {
            title:
              currentColorProducts &&
              currentColorProducts?.[0]?.title +
                ' (' +
                currentPower?.title +
                ' ' +
                powerOptions?.label +
                ')',
            eyeImageUrl:
              currentColorProducts && currentColorProducts?.[0]?.optionData?.thumbnailImage,
          };
        });
    }
    if (!activeProductData)
      activeProductData = {
        title: colorOptions?.[0]?.title,
        eyeImageUrl: colorOptions?.[0]?.optionData?.thumbnailImage,
      };
    return { optionsMapping, colorOptions, powerOptions, activeProductData };
  }, [data?.additionalOptions]);

  useEffect(() => {
    if (activeProductData && !currentProduct) setCurrentProduct(activeProductData);
    return () => {};
  }, [activeProductData]);

  const clickHandler = arrow => {
    const eproject = outerRef.current;
    const ecard = document.querySelector('.cl-widget-card-holder');
    const elWidth = ecard?.offsetWidth;
    const style = ecard?.currentStyle || window.getComputedStyle(ecard);
    const elMargin =
      parseInt(style?.getPropertyValue('margin-left'), 10) +
      parseInt(style?.getPropertyValue('margin-right'), 10);
    const maxScrollLeft = eproject?.scrollWidth - eproject?.clientWidth;
    const scrollLength = elMargin + elWidth;

    if (arrow === 'prev') {
      if (eproject?.scrollLeft - scrollLength <= 0) {
        prevArrowRef.current.style.display = 'none';
        nextArrowRef.current.style.display = 'flex';
        eproject.scrollLeft = 0;
      } else {
        prevArrowRef.current.style.display = 'flex';
        nextArrowRef.current.style.display = 'flex';
        eproject.scrollLeft -= scrollLength;
      }
    } else if (Math.round(eproject?.scrollLeft + scrollLength) >= maxScrollLeft) {
      nextArrowRef.current.style.display = 'none';
      prevArrowRef.current.style.display = 'flex';
      eproject.scrollLeft = maxScrollLeft;
    } else {
      prevArrowRef.current.style.display = 'flex';
      nextArrowRef.current.style.display = 'flex';
      eproject.scrollLeft += scrollLength;
    }
  };

  useEffect(() => {
    if (categoryData?.result) deleteCategoryData();
  }, [categoryData?.result]);

  useEffect(() => {
    if (innerRef?.current && outerRef?.current) {
      const eproject = outerRef.current;
      const maxScrollLeft = eproject?.scrollWidth - eproject?.clientWidth;
      const innerWidth = innerRef.current?.getBoundingClientRect()?.width;
      const outerWidth = outerRef.current?.getBoundingClientRect()?.width;
      if (nextArrowRef?.current && prevArrowRef?.current) {
        if (innerWidth <= outerWidth) {
          nextArrowRef.current.style.display = 'none';
          prevArrowRef.current.style.display = 'none';
        } else if (eproject?.scrollLeft === 0) {
          prevArrowRef.current.style.display = 'none';
          nextArrowRef.current.style.display = 'flex';
        } else if (eproject?.scrollLeft === maxScrollLeft) {
          prevArrowRef.current.style.display = 'flex';
          nextArrowRef.current.style.display = 'none';
        } else {
          prevArrowRef.current.style.display = 'flex';
          nextArrowRef.current.style.display = 'flex';
        }
      }
    }
  }, [outerRef.current, innerRef.current, data, data?.additionalOptions]);

  const cardTapped = useCallback(item => {
    const clCardTapped = {
      event: 'CL_Color_Widget_Clicked',
      device: 'Mobile',
      clicks: 1,
    };
    const exists = window.dataLayer?.some(dl => dl?.event === 'CL_Color_Widget_Clicked');
    if (exists) {
      const newWindowLayer = window.dataLayer?.map(dl => {
        if (dl?.event === 'CL_Color_Widget_Clicked') {
          return {
            event: 'CL_Color_Widget_Clicked',
            device: 'Desktop',
            clicks: dl?.clicks + 1,
          };
        }
        return dl;
      });
      window.dataLayer = newWindowLayer;
    } else {
      window.dataLayer.push(clCardTapped);
    }
    history?.push('/product/' + item?.productId);
  }, []);

  const addButtonClicked = useCallback(pid => {
    const clAddButton = {
      event: 'CL_Add_Button_Clicked',
      device: 'Desktop',
      clicks: 1,
    };
    const exists = window.dataLayer?.some(dl => dl?.event === 'CL_Add_Button_Clicked');
    if (exists) {
      const newWindowLayer = window.dataLayer?.map(dl => {
        if (dl?.event === 'CL_Add_Button_Clicked') {
          return {
            event: 'CL_Add_Button_Clicked',
            device: 'Desktop',
            clicks: dl?.clicks + 1,
          };
        }
        return dl;
      });
      window.dataLayer = newWindowLayer;
    } else {
      window.dataLayer?.push(clAddButton);
    }
    props?.onClick(pid);
  }, []);

  return data?.additionalOptions &&
    optionsMapping &&
    colorOptions &&
    powerOptions &&
    currentProduct ? (
    <div className="clc-page">
      {!isMobile && <h1 className="clc-heading">{currentProduct && currentProduct?.title}</h1>}
      {colorOptions[0]?.imageUrl && !isMobile ? (
        <div className="currentImage-container">
          <img
            alt=""
            className="currentImage"
            src={currentProduct && currentProduct?.eyeImageUrl}
          />
        </div>
      ) : null}

      <h4 className={!isMobile ? 'clc-info-desktop' : 'clc-info-mobile'}>
        {!isMobile ? 'Hover on cards to view the lens' : 'Tap on cards to view the lens'}
      </h4>
      <div className="clc-slider" onMouseLeave={() => setCurrentProduct(activeProductData)}>
        {!isMobile && (
          <div ref={prevArrowRef} className="prev-arrow-container arrow-container">
            <div className="prev-arrow" onClick={() => clickHandler('prev')}>
              <svg height="20" viewBox="0 0 140 140" width="20" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    fill="black"
                  />
                </g>
              </svg>
            </div>
          </div>
        )}

        <div ref={outerRef} className="clc-container">
          <div ref={innerRef} className={`clc-holder ${isMobile ? 'clc-mobile' : ''}`}>
            {optionsMapping?.map(item => {
              const currentColorProducts = colorOptions?.filter(c => c?.id === item?.color);
              const currentPower = powerOptions?.optionList?.filter(
                p => p?.id === item?.power
              )?.[0];
              return currentColorProducts?.length > 0 && currentPower ? (
                <div
                  key={item?.productId}
                  className={
                    data?.id === item?.productId
                      ? 'cl-widget-card-holder active-card'
                      : 'cl-widget-card-holder'
                  }
                  onClick={() => {
                    if (isMobile) {
                      if (categoryData?.result)
                        window.location.href = '/product/' + item?.productId;
                      else cardTapped(item);
                    }
                  }}
                  onMouseEnter={() => {
                    setCurrentProduct({
                      title:
                        currentColorProducts?.[0]?.title +
                        ' (' +
                        currentPower?.title +
                        ' ' +
                        powerOptions?.label +
                        ')',
                      eyeImageUrl: currentColorProducts?.[0]?.optionData?.thumbnailImage,
                    });
                  }}
                >
                  <img alt="img" className="cou-img" src={currentColorProducts?.[0]?.imageUrl} />
                  <label className="cou-lab" title={currentColorProducts?.[0]?.title}>
                    {currentColorProducts?.[0]?.title +
                      ' (' +
                      currentPower?.title +
                      ' ' +
                      powerOptions?.label +
                      ')'}
                  </label>
                  {!isMobile && (
                    <button
                      className="contact-lens-inactive"
                      style={{ backgroundColor: '#fff' }}
                      onClick={() => addButtonClicked(item?.productId)}
                    >
                      Add
                    </button>
                  )}
                </div>
              ) : null;
            })}
          </div>
        </div>
        {!isMobile && (
          <div ref={nextArrowRef} className="next-arrow-container arrow-container">
            <div className="next-arrow" onClick={() => clickHandler('next')}>
              <svg height="20" viewBox="0 0 140 140" width="20" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    fill="black"
                  />
                </g>
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : null;
};

const mapStateToProps = state => ({
  categoryData: state.category.categoryData,
});

function mapDispatchToProps(dispatch) {
  return {
    deleteCategoryData: () => dispatch(deleteCategoryData()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactLensCarousel);
